import { type TProduct, getBillingProductsnUrl, withQuery } from '@core/api'
import { httpClient } from '@core/http-client'

import { convertProduct } from '@core/converters'

export const getBillingProducts = async (params: { signal?: AbortSignal; products: string[] }) => {
    const apiProducts = await httpClient
        .get(withQuery(getBillingProductsnUrl(), { only: params.products.join(',') }), {
            signal: params.signal,
        })
        .json<TProduct[]>()

    return apiProducts.map(convertProduct)
}
